import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'

type OnboardingNoApplicableStandardsStepProps = {
  onContinue?: () => void
}

export function OnboardingNoApplicableStandardsStep({
  onContinue,
}: OnboardingNoApplicableStandardsStepProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  return (
    <div className='space-y-6 py-12 text-center'>
      <p className='mb-4 text-muted-foreground'>
        {t('onboarding.noApplicableStandards')}
      </p>
      {onContinue != null && (
        <Button type='button' onClick={onContinue}>
          {t('onboarding.intro.continue')}
        </Button>
      )}
    </div>
  )
}
